













































import { Component, Prop, Vue } from 'vue-property-decorator'
import ShareToFacebook from '~components/social/ShareToFacebook.vue'
import ShareToTwitter from '~components/social/ShareToTwitter.vue'
import ShareToWhatsapp from '~components/social/ShareToWhatsapp.vue'
import ShareToFacebookMessenger from '~components/social/ShareToFacebookMessenger.vue'
import ShareToClipboard from '~components/social/ShareToClipboard.vue'
import OnClickOutside from '~components/utils/OnClickOutside.vue'

@Component({
  components: {
    ShareToFacebook,
    ShareToTwitter,
    ShareToWhatsapp,
    ShareToFacebookMessenger,
    ShareToClipboard,
    OnClickOutside,
  },
})
export default class SocialBookmarks extends Vue {
  @Prop({ type: String, required: true }) readonly url!: string
  @Prop({ type: String, required: true }) readonly text!: string

  private show: boolean = false
}
